import Svg, { SvgEnum } from "../ui library/components/svgs/standard/svg";
import HNSColors from "../ui library/HNSColors";

const NotificationBadge = ({ count = 0 }) => {
  const normalizedCount = Number.isFinite(count) ? count : 0;
  const shouldRenderCount = normalizedCount > 0;
  const badgeLabel = normalizedCount > 99 ? "99+" : normalizedCount;

  return (
    <div className="relative inline-block">
      {shouldRenderCount ? (
        <span
          className="absolute left-[8px] top-[10px] flex h-[14px] w-[14px] items-center justify-center rounded-full text-[8px] font-bold text-white"
          style={{ backgroundColor: HNSColors.failure[500], lineHeight: 1 }}
        >
          {badgeLabel}
        </span>
      ) : null}
      <div
        className="flex h-12 w-12 items-center justify-center rounded-full"
        style={{ backgroundColor: HNSColors.secondary[500] }}
      >
        <Svg name={SvgEnum.HisAI} sx={{ height: "22px", width: "22px" }} color="#ffffff" />
      </div>
    </div>
  );
};

export default NotificationBadge;
